import React, { useEffect, useState } from 'react'
import plus from '../dist/webImages/plus.png'
import ReviewsModel from './ReviewsModel';
import ReviewsCard from './ReviewsCard';
import SkeletonReviewsCard from './SkeletonReviewsCard';
import { Link } from 'react-router-dom';
import useGet from '../customHooks/useGet';

const Reviews = ({permission}) => {
      const [resget, apiMethodGet] = useGet()
  const [datas, setDatas] = useState()
        useEffect(() => {
                apiMethodGet(`googleReview`);
            
        }, []);
        useEffect(() => {
            if (!resget.isLoading) {
                setDatas(resget?.data?.data)
            }
        }, [resget.data])
const check = (module, action) => permission?.[module]?.includes(action);

    return (
        <div className='ReviewsPage '>
            <div className="ReviewsPageTop flex justify-between items-center">
                <h6 className='text-[1rem] mb-2 bookingSectionh relative px-3 font-Mluvka'>Reviews</h6>
                <Link to={"/reviews/create"} className='bg-[#A38560]/50 py-2 px-4 rounded-full flex items-center gap-2 cursor-pointer'>
                    <img src={plus} alt="plus" className="w-6" />
                    <span className='font-MluvkaBold text-secondary capitalize text-[.9rem]'>Add new</span>
                </Link>
            </div>
            <div className="ReviewsPageGrid mt-4 bg-[#EFF4FD] rounded-3xl p-6 grid grid-cols-3 gap-3 max-lg:grid-cols-1 max-lg:p-3">
            {resget.isLoading ? 
                         Array.from({ length: 8 }).map((_, index) => (
                            <React.Fragment key={index}>
                            <SkeletonReviewsCard  />
                        </React.Fragment>
                         ))
                        :
                        Array.isArray(datas) &&
                        datas
                       .map((item, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <ReviewsCard permission={permission} data={item}  alldata={datas} deleted={setDatas} />
                                </React.Fragment>
                            )
                        })}
            </div>
        </div>
    )
}

export default Reviews
